<div class="page-footer">
    <div class="page-footer__content">
        <a class="page-footer__link" (click)="openTermsAndConditions()">{{ 'COMMON.TERMS_AND_CONDITIONS' | translate }}</a>
        <a class="page-footer__link" (click)="openPrivacyPolicy()">{{ 'COMMON.PRIVACY_POLICY' | translate }}</a>
        <a class="page-footer__link" (click)="openImpressum()">Impressum</a>
    </div>
</div>
